// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__XaCvd","file":"styles_file__RaOJQ"};